import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_GROUPCONTRACT_LOAD_BY_GROUP_ID,
    ACTION_GROUPCONTRACT_LOAD_BY_ID,

    ACTION_GROUPCONTRACT_SAVE,

    ACTION_GROUPCONTRACT_CREATE,

    ACTION_GROUPCONTRACT_VALIDATE,

    IGroupContractLoadByGroupIdAction,
    IGroupContractLoadByIdAction,
    IGroupContractLoadFailureAction,
    IGroupContractLoadSuccessAction,

    IGroupContractSaveAction,
    IGroupContractSaveSuccessAction,
    IGroupContractSaveFailureAction,

    IGroupContractCreateAction,
    IGroupContractCreateSuccessAction,
    IGroupContractCreateFailureAction,

    IGroupContractValidateAction,
    IGroupContractValidateSuccessAction,
    IGroupContractValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/groupContract";
import { groupContractApi } from "../services/groupContract";

export const
    getGroupContractByGroupIdEpic = (action$): Observable<IGroupContractLoadSuccessAction | IGroupContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONTRACT_LOAD_BY_GROUP_ID)
            .mergeMap((action: IGroupContractLoadByGroupIdAction) => {
                return groupContractApi
                    .getGroupContractByGroupId(action.groupId)
                    .map(response =>
                        LoadSuccess(response.groupContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getGroupContractByIdEpic = (action$): Observable<IGroupContractLoadSuccessAction | IGroupContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONTRACT_LOAD_BY_ID)
            .mergeMap((action: IGroupContractLoadByIdAction) => {
                return groupContractApi
                    .getGroupContractById(action.id)
                    .map(response =>
                        LoadSuccess(response.groupContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setGroupContractEpic = (action$): Observable<IGroupContractSaveSuccessAction | IGroupContractSaveFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONTRACT_SAVE)
            .mergeMap((action: IGroupContractSaveAction) => {
                return groupContractApi
                    .setGroupContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.groupContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createGroupContractEpic = (action$): Observable<IGroupContractCreateSuccessAction | IGroupContractCreateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONTRACT_CREATE)
            .mergeMap((action: IGroupContractCreateAction) => {
                return groupContractApi
                    .createGroupContract(action.groupId)
                    .map(response =>
                        CreateSuccess(
                            response.groupContract,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateGroupContractEpic = (action$): Observable<IGroupContractValidateSuccessAction | IGroupContractValidateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPCONTRACT_VALIDATE)
            .mergeMap((action: IGroupContractValidateAction) => {
                return groupContractApi
                    .validateGroupContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.groupContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }